import type React from "react";
import { useTranslation } from "react-i18next";

import { ParagraphMedium } from "styles/elements/Texts";
import { CssIcon } from "styles/helpers/layout";
import { type NoteVariant, StyledNote } from "./Note.styled";

export interface NoteProps {
  children: React.ReactNode;
  className?: string;
  dataCy?: string;
  showIcon?: boolean;
  variant?: NoteVariant;
  hideNotePrefix?: boolean;
}

export const Note: React.FC<NoteProps> = ({
  className,
  children,
  dataCy,
  showIcon = false,
  hideNotePrefix = false,
  variant = "info",
}) => {
  const { t } = useTranslation("common");

  const notePrefix =
    variant === "info" ? t("common:note.label.info") : t("common:note.label.default");

  const variantIconMap: Record<NoteVariant, string> = {
    info: "fas fa-info-circle",
    warning: "fas fa-exclamation-triangle",
    error: "fas fa-times-circle",
    success: "fas fa-check-circle",
  };

  return (
    <StyledNote $variant={variant} className={className} data-cy={dataCy}>
      {showIcon && <CssIcon iconName={variantIconMap[variant]} />}
      <ParagraphMedium>
        {!hideNotePrefix && <b>{notePrefix}:</b>} {children}
      </ParagraphMedium>
    </StyledNote>
  );
};
